export const techNewsData = [
  {
    id: 1,
    title:
      " Atlassian launches Jira Work Management, opening its Jira platform to all b ... ",
    date: " 2021-04-28",
    img: "https://cse.mbstu.ac.bd/storage/48/download-2-1536x747-100886506-large.jpg",
    alt: "article about Atlassian launches Jira Work Management, opening its Jira platform to all",
  },
  {
    id: 2,
    title:
      " MBSTU has stood 3rd out of 28 universities in Bangladesh this year in the ... ",
    date: " 2021-04-21",
    img: "https://cse.mbstu.ac.bd/storage/50/180492157_757201811827715_5772206346589761407_n.png",
    alt: "article about MBSTU has stood 3rd out of 28 universities in Bangladesh this year",
  },
  {
    id: 3,
    title:
      " Toward deep-learning models that can reason about code more like humans ",
    date: " 2021-04-15",
    img: "https://cse.mbstu.ac.bd/storage/47/coding-AI.png",
    alt: "article about Toward deep-learning models that can reason about code more like humans",
  },
  {
    id: 4,
    title:
      " CSE, MBSTU stepped up ranking in ICPC Dhaka Regional 2020 Online Preliminar ... ",
    date: " 2021-04-07",
    img: "https://cse.mbstu.ac.bd/storage/49/162676804_173997927869163_6903216474341855063_n.jpg",
    alt: "article about CSE, MBSTU stepped up ranking in ICPC Dhaka Regional 2020 Online Preliminar",
  },
  {
    id: 5,
    title:
      " Google Doodle Encourages People to Get COVID-19 Vaccine, Wear Face Masks. ",

    date: " 2021-05-01",
    img: "https://cse.mbstu.ac.bd/storage/44/google_doodle_covid_19_vaccine_image_1619857440356.jpg",
    alt: "article about Google Doodle Encourages People to Get COVID-19 Vaccine, Wear Face Masks. ",
  },
  {
    id: 6,
    title:
      " Computer scientists discover new vulnerability affecting computers globally ... ",
    alt: "article about Computer scientists discover new vulnerability affecting computers globally ",
    date: " 2021-04-30",
    img: "https://cse.mbstu.ac.bd/storage/46/online-fraud-representational.jpg",
  },
  {
    id: 7,
    title: " AI is improving Google Assistant conversations. ",
    alt: "article about AI is improving Google Assistant conversations. ",
    date: " 2021-04-29",
    img: "https://cse.mbstu.ac.bd/storage/45/ai-is-improving-google.jpg",
  },
];
